export default __webpack_public_path__ + "static/media/arrow_right.46e1df3e.svg";